var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":"请选择发票类型","clearable":_vm.clearable,"idKey":"InvoiceTypeId","labelKey":"InvoiceTypeName","get-data-func":_vm.getDataFunc},on:{"select":(v,e,type)=>_vm.$emit('change',v,e,type),"input":(v,e,type)=>_vm.$emit('input',v,e,type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }